
export default (Vue, options = {}) => {
    const addListener = async (ele, binding) => {
        let imgURL = binding.value; //获取图片地址
        if (imgURL) {
            let exist = await imageIsExist(imgURL);
            if (exist) {
                ele.setAttribute('src', imgURL);
            }

        }
    }
    const imageIsExist = function (url) {
        return new Promise((resolve) => {
            var img = new Image();
            img.onload = function () {
                if (this.complete == true) {
                    resolve(true);
                    img = null;
                }
            }
            img.onerror = function () {
                resolve(false);
                img = null;
            }
            img.src = url;
        })
    }
    Vue.directive('real-img', {
        inserted: addListener,
        update: addListener
    })
}
